import React, { useState } from "react"
import styled from '@emotion/styled/macro'
import { StaticImage } from "gatsby-plugin-image"
import { Theme2, Device } from "../Layout"
import { useServiceAreasSectionQuery } from '../../hooks/use-service-areas-section-query'
import { useResultsQuery } from '../../hooks/use-results-query'
import { RedPolygon } from "../SVGs"
import AccordionContent from "../AccordionContent"

const ServiceAreasSection = ({isHomePage, pageTitle}) =>{


const ServiceAreasSectionOuterContainer = styled.div`
//display: grid;
position: relative;
box-sizing: border-box;
text-align: center;
//overflow-y: hidden;
background-color: ${isHomePage === true ? Theme2.colors.neutral : `transparent`};

.helpingWhite{
  position: absolute;
  height: 100%;
}
.ServiceAreasSectionInnerContainer{
  //grid-area: 1/1;
  position: relative;
   max-width: 100%;
  padding: ${isHomePage === true ? `3rem 2rem 4rem 2rem` : 0};
  margin: 0 auto;
  //overflow-y: hidden;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    overflow-x: hidden;

    @media(min-width: 992px){
      max-width: ${isHomePage === true ? `75rem` : `100%`};
    }
}
.ServiceAreasSectionTitle{
  line-height: 1.1;
font-family: ${Theme2.fonts.headings};
font-size: 35px;
font-weight: 700;
margin-bottom: 1rem;
max-width: 970px;
margin: 0 auto;

@media ${Device.sm}{
font-size: calc(35px + 35 * ((100vw - 576px) / 624));
}
@media ${Device.xl}{
  font-size: 70px;
  margin-bottom: 2rem;
}

  .red{
color: ${Theme2.colors.tertiary};
  }
}
.ServiceAreasSectionSubtitle{
font-family: ${Theme2.fonts.alternateHeadings};
font-size: 24px;
font-style: italic;
color: ${Theme2.colors.primary};
max-width: 970px;
margin: 1rem auto;

@media ${Device.sm}{
font-size: calc(24px + 8 * ((100vw - 576px) / 624));
}
@media ${Device.xl}{
  font-size: 32px;
}
}
.homeH1{
  font-size: 13px;
  margin-bottom: 1rem;
  @media ${Device.sm}{
font-size: calc(13px + 3 * ((100vw - 576px) / 624));
}
@media ${Device.xl}{
  font-size: 16px;
}
}
.videoSectionParagraph{
  margin-top: 1.6rem;
  display: inline-block;
}
.ulContainer{
  white-space: ${isHomePage === true ? `nowrap` : `normal`};
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  text-align: center;

  @media ${Device.lg}{
    margin: 2.5rem 0;
  }
}
ul{
  display: inline-grid;
  grid-template-columns: repeat(3, auto);
  margin-left: 0;
  grid-gap: 1rem;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  list-style: none;

  @media ${Device.lg}{
    grid-gap: 0;
    justify-content: ${isHomePage === true ? `center` : `flex-start`};
  }

  button{
    display: inline;
    appearance: none;
    border: none;
    background-color: transparent;
    color: ${Theme2.colors.footerColor};
    text-transform: uppercase;
    font-size: 15px;
    padding: 0 0 15px 0;
    border-bottom: 3px solid transparent;

    @media ${Device.sm}{
      font-size: calc(15px + 7 * ((100vw - 576px) / 624));
    }
    @media ${Device.lg}{
      background-color: #F5F5F5;
      padding: 34px 56px;
      border: 1px solid #EBEBEB;
    }
    @media ${Device.xl}{
    font-size: 22px;
  }
  }
  
  .active{
    color: ${Theme2.colors.tertiary};
    border-bottom: 3px solid ${Theme2.colors.tertiary};
    @media ${Device.lg}{
      color: ${Theme2.colors.light};
      background-color: ${Theme2.colors.tertiary};
      border-bottom: 0;
      position: relative;

      &:after{
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border-top: 10px solid ${Theme2.colors.tertiary};
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
      }
    }
  }
}

 .redPolygonContainer{
   display: none;

   @media (min-width: 992px){
     display: inherit;
     position: absolute;
     left: 0;
     bottom: 0;
     min-height: 100%;

     svg{
      min-height: 100%;
      width: auto;
     }
   }
 }

`


  const { serviceAreasTitleBlack1,
    serviceAreasTitleRed,
    serviceAreasTitleBlack2,
    serviceAreasSubtitle
     } = useServiceAreasSectionQuery()

    const { resultsTabs } = useResultsQuery()
  

  const [resultsTitle2, setResultsTitle2] = useState(
    resultsTabs[0].resultsTabTitle
    )
  const [selectedMenuItemIndex, setSelectedMenuItemIndex] = useState(0)


  
    return(
      
        <ServiceAreasSectionOuterContainer >
          
        {isHomePage === true &&
        <>
        <StaticImage src="../../images/helping-white.png" layout="fullWidth" style={{
          gridArea: "1/1",
          position: "absolute",
          minHeight: "500px",
          width: "100%"
        }}
      formats={["auto", "webp", "avif"]} />
      <div className="redPolygonContainer">
        <RedPolygon />
      </div>
        </>
}
        <div className="ServiceAreasSectionInnerContainer">
        {isHomePage === true &&
          <div>
       <p className="ServiceAreasSectionTitle">{serviceAreasTitleBlack1} <span className="red">{serviceAreasTitleRed}</span> {serviceAreasTitleBlack2}</p>
        <p className="ServiceAreasSectionSubtitle">{serviceAreasSubtitle}</p>
        
        </div>
}
<div className="ulContainer">
        <ul>
        {resultsTabs.map((tabTitle, i) => {
const { resultsTabTitle } = tabTitle;
        return(
          <>
<li key={i}>
        <button
        
          className={i === selectedMenuItemIndex ? 'active' : ''}
          onClick={() => {setSelectedMenuItemIndex(i); setResultsTitle2(resultsTabTitle)}}>
          {resultsTabTitle}
        </button>
      </li>
      
      </>
        )
      
  })}
  </ul>
</div>
<AccordionContent isHomePage={isHomePage === true ? true : false} resultsTabTitle={resultsTitle2} pageTitle={pageTitle} />

  
</div>

</ServiceAreasSectionOuterContainer>
        
    )
}

export default ServiceAreasSection